import type { PurchaseOrderLine } from "@/features/purchase/types";
import {
  calcWtPerMm,
  materialFieldRules,
  type MaterialFieldRules,
} from "@/features/purchase/material-fields";

/** @deprecated use materialFieldRules — kept for receive imports */
export type ReceiveFieldRules = MaterialFieldRules;

export { calcWtPerMm, materialFieldRules };

export function receiveFieldRules(
  line: Pick<
    PurchaseOrderLine,
    "material_id" | "material_name" | "requires_shape_size" | "parent_material_id"
  >,
): ReceiveFieldRules {
  return materialFieldRules({
    material_id: line.material_id,
    material_name: line.material_name,
    requires_shape_size: line.requires_shape_size,
    parent_material_id: line.parent_material_id,
  });
}
